/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentCard/view.blocks to change it.
import Content from './Content/index'
import PaymentsTreatmentPlan from './PaymentsTreatmentPlan/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TreatmentCard({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard"
  
}) {
  return (<React.Fragment
>
<Content
  viewPath={`${viewPath}/Content`}
/>
<PaymentsTreatmentPlan
  viewPath={`${viewPath}/PaymentsTreatmentPlan`}
/>
{children}
</React.Fragment>)
}